import React from 'react';
import { Upload } from 'lucide-react';

export interface CurriculumTarget {
  id: string;
  title: string;
  subject: string;
}

interface CurriculumTargetSelectorProps {
  targets: CurriculumTarget[];
  selectedTarget: string;
  onSelectTarget: (targetId: string) => void;
  onAddTarget: () => void;
  disabled?: boolean;
}

export function CurriculumTargetSelector({
  targets,
  selectedTarget,
  onSelectTarget,
  onAddTarget,
  disabled = false
}: CurriculumTargetSelectorProps) {
  return (
    <div>
      <div className="flex items-center justify-between mb-3">
        <label htmlFor="curriculum-target-select" className="block text-sm font-semibold text-gray-700">
          Curriculum Targets (Optional)
        </label>
        <button
          onClick={onAddTarget}
          disabled={disabled}
          className="flex items-center space-x-2 px-3 py-1.5 bg-blue-100 text-blue-700 rounded-lg hover:bg-blue-200 transition-colors text-sm disabled:opacity-50 disabled:cursor-not-allowed"
        >
          <Upload className="w-4 h-4" />
          <span>Add Target</span>
        </button>
      </div>

      {targets.length > 0 ? (
        <select
          id="curriculum-target-select"
          value={selectedTarget}
          onChange={(e) => onSelectTarget(e.target.value)}
          disabled={disabled}
          className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          <option value="">Select a curriculum target (optional)</option>
          {targets.map((target) => (
            <option key={target.id} value={target.id}>
              {target.title} - {target.subject}
            </option>
          ))}
        </select>
      ) : (
        <div className="text-center py-4 text-gray-500 text-sm">
          No curriculum targets uploaded yet. Add one to create more targeted activities.
        </div>
      )}
    </div>
  );
}
